<template>
  <section
    class="slds-notification"
    role="dialog"
    aria-labelledby="noti77"
    :aria-describedby="`dialog-body-id-${id}`">
    <div class="slds-notification__body" :id="`dialog-body-id-${id}`">
      <a class="slds-notification__target slds-media" href="javascript:void(0);" @click="goToUrl">
        <span class="slds-icon_container slds-icon-standard-campaign slds-media__figure" v-if="icon === 'preview'">
          <svg class="slds-icon slds-icon_small">
            <use xlink:href="../../assets/icons/standard-sprite/svg/symbols.svg#chart" />
          </svg>
        </span>
        <span class="slds-icon_container slds-icon-standard-assigned-resource slds-media__figure" v-else-if="icon === 'target'">
          <svg class="slds-icon slds-icon_small">
            <use xlink:href="../../assets/icons/action-sprite/svg/symbols.svg#share_file" />
          </svg>
        </span>
        <span class="slds-icon_container slds-icon-standard-campaign slds-media__figure" v-else-if="icon === 'campaign'">
          <svg class="slds-icon slds-icon_small">
            <use xlink:href="../../assets/icons/utility-sprite/svg/symbols.svg#sync" />
          </svg>
        </span>
        <div class="slds-media__body">
          <h2 class="slds-text-heading_small slds-m-bottom_xx-small" id="noti77">
            <span class="slds-assistive-text">{{title}}</span>{{title}}
          </h2>
          <p>{{text}}</p>
        </div>
      </a>
      <button class="slds-button slds-button_icon slds-button_icon-container slds-notification__close" :title="`${$t('action.dismiss')} ${title}`" @click="$emit('removeNotification', id)">
        <svg class="slds-button__icon" aria-hidden="true">
          <use xlink:href="../../assets/icons/utility-sprite/svg/symbols.svg#close" />
        </svg>
        <span class="slds-assistive-text">{{$t('action.dismiss')}}</span>
      </button>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    icon: String,
    id: Number,
    title: String,
    text: String,
    url: String
  },
  methods: {
    goToUrl () {
      if (this.url) {
        if (this.$route.fullPath !== this.url) {
          this.$router.push(this.url)
        }
        this.$emit('removeNotification', this.id)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  // .container {
  //   position: absolute;
  // }
</style>
